(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caboki-aviso-social"]) return;
  try {
    
  (() => {
    const CLAVE_CERRADO = 'cb-aviso-cerrado';
    const CLAVE_TURNO = 'cb-aviso-turno';
    const SALIDA = 320;

    const leeSesion = (clave) => {
      try {
        return sessionStorage.getItem(clave);
      } catch (e) {
        return null;
      }
    };

    const guardaSesion = (clave, valor) => {
      try {
        sessionStorage.setItem(clave, valor);
      } catch (e) {
        /* navegacion privada con almacenamiento bloqueado: se pierde la memoria, no la pagina */
      }
    };

    const arranca = () => {
      const caja = document.querySelector('[data-cb-aviso]');
      if (!caja || caja.dataset.cbListo === '1') return;
      if (leeSesion(CLAVE_CERRADO) === '1') return;

      const items = Array.from(caja.querySelectorAll('[data-cb-item]'));
      if (!items.length) return;

      /* El turno se guarda en la sesion: si no, cada pagina volveria a empezar por la primera
         resena y el visitante veria siempre la misma. Asi la rotacion continua donde se quedo
         aunque se cambie de pagina.
         El ciclo NO para: se pidio verlas mas a menudo. La salida sigue estando en la aspa, que
         lo apaga para toda la sesion; sin ese boton, un aviso que vuelve cada pocos segundos y
         no se puede callar seria hostil. */
      let turno = parseInt(leeSesion(CLAVE_TURNO) || '0', 10);
      if (!Number.isFinite(turno) || turno < 0) turno = 0;

      caja.dataset.cbListo = '1';

      const espera = parseInt(caja.dataset.espera, 10) || 5000;
      const visible = parseInt(caja.dataset.visible, 10) || 6000;
      const hueco = parseInt(caja.dataset.hueco, 10) || 8000;

      let reloj = null;
      let pausado = false;

      const programa = (ms, fn) => {
        clearTimeout(reloj);
        reloj = setTimeout(fn, ms);
      };

      const esconde = (alTerminar) => {
        caja.classList.remove('is-visible');
        setTimeout(() => {
          caja.hidden = true;
          items.forEach((el) => {
            el.hidden = true;
          });
          if (alTerminar) alTerminar();
        }, SALIDA);
      };

      const muestra = () => {
        const cual = turno % items.length;
        items.forEach((el, n) => {
          el.hidden = n !== cual;
        });
        caja.hidden = false;
        requestAnimationFrame(() => caja.classList.add('is-visible'));
        programa(visible, pasaTurno);
      };

      const pasaTurno = () => {
        /* Si el visitante lo tiene bajo el raton o enfocado con el teclado, esta leyendolo:
           no se le quita de delante. Se vuelve a mirar en un segundo. */
        if (pausado) {
          programa(1000, pasaTurno);
          return;
        }
        turno += 1;
        guardaSesion(CLAVE_TURNO, String(turno));
        esconde(() => {
          programa(hueco, muestra);
        });
      };

      const cierra = () => {
        clearTimeout(reloj);
        guardaSesion(CLAVE_CERRADO, '1');
        esconde();
      };

      caja.querySelector('[data-cb-cerrar]')?.addEventListener('click', cierra);

      caja.addEventListener('mouseenter', () => {
        pausado = true;
      });
      caja.addEventListener('mouseleave', () => {
        pausado = false;
      });
      caja.addEventListener('focusin', () => {
        pausado = true;
      });
      caja.addEventListener('focusout', () => {
        pausado = false;
      });

      programa(espera, muestra);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arranca);
    } else {
      arranca();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caboki-categorias"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Shopify solo empaqueta el JS de las secciones que se RENDERIZAN en cada pagina, asi que
    // `window.cbRevelar` -que define `caboki-uso`- no existe en el home. Comprobado en el servido:
    // salia `undefined`. Por eso la seccion define el ayudante si falta, en vez de depender de otra.
    if (!window.cbRevelar) {
      var observador = null;
      if ('IntersectionObserver' in window) {
        observador = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (!entrada.isIntersecting) return;
            entrada.target.classList.add('cb-in');
            observador.unobserve(entrada.target);
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
      }
      window.cbRevelar = function (raiz) {
        if (!observador) return;
        raiz.setAttribute('data-cb-anim', 'on');
        raiz.querySelectorAll('[data-cb-reveal]').forEach(function (el) {
          // Lo que ya se ve al cargar entra revelado, para que no parpadee.
          if (el.getBoundingClientRect().top < window.innerHeight * 0.9) { el.classList.add('cb-in'); return; }
          observador.observe(el);
        });
      };
    }

    function arranca(raiz) {
      if (window.cbRevelar) window.cbRevelar(raiz);
    }
    document.querySelectorAll('[data-cb-cats]').forEach(arranca);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-cb-cats]').forEach(arranca);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caboki-contacto"] && !Shopify.designMode) return;
  try {
    
  // Lo unico que hace: llevar el foco al aviso de exito o de error despues de enviar. Sin esto,
  // quien usa lector de pantalla envia el formulario y no recibe ninguna señal de que ha pasado.
  (function () {
    var aviso = document.querySelector('[data-cb-contacto-ok], [data-cb-contacto-error]');
    if (aviso) aviso.focus();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caboki-faq-cards"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cb-faqc__item').forEach(function (item) {
    var summary = item.querySelector('.cb-faqc__q');
    if (!summary) return;
    var sync = function () { summary.setAttribute('aria-expanded', item.open ? 'true' : 'false'); };
    sync();
    item.addEventListener('toggle', sync);
  });

  document.querySelectorAll('.cb-faqc').forEach(function (root) {
    var input = root.querySelector('[data-cb-faq-search]');
    var list = root.querySelector('[data-cb-faq-list]');
    if (!input || !list) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-cb-faq-item]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-cb-faq-cat]'));
    var count = root.querySelector('[data-cb-faq-count]');
    var empty = root.querySelector('[data-cb-faq-empty]');
    var cat = '';

    // Sin quitar acentos, "fijacion" no encuentra "fijación" y el buscador parece roto.
    function norm(s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    var plantillaUna = count ? count.getAttribute('data-plantilla-una') || '' : '';
    var plantillaVarias = count ? count.getAttribute('data-plantilla-varias') || '' : '';

    function apply() {
      var q = norm(input.value).trim();
      var visibles = 0;
      items.forEach(function (item) {
        var okCat = !cat || item.getAttribute('data-cb-cat') === cat;
        var okText = !q || norm(item.getAttribute('data-cb-text')).indexOf(q) !== -1;
        var ok = okCat && okText;
        item.hidden = !ok;
        if (!ok) item.open = false;
        if (ok) visibles++;
      });
      if (empty) empty.hidden = visibles !== 0;
      if (count) {
        var plantilla = visibles === 1 ? plantillaUna : plantillaVarias;
        count.textContent = plantilla.replace('{n}', String(visibles));
      }
    }

    input.addEventListener('input', apply);
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        cat = chip.getAttribute('data-cb-faq-cat') || '';
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        apply();
      });
    });
    apply();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caboki-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cb-faq__item').forEach(function (item) {
    var summary = item.querySelector('.cb-faq__q');
    if (!summary) return;
    var sync = function () { summary.setAttribute('aria-expanded', item.open ? 'true' : 'false'); };
    sync();
    item.addEventListener('toggle', sync);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caboki-header"]) return;
  try {
    
  /* Abre el buscador predictivo que el tema ya trae montado en todas las paginas, en lugar de
     navegar. Se comprueba que el modal EXISTE y que expone showDialog antes de cancelar la
     navegacion: si no esta, no se toca el enlace y el clic lleva a /search como siempre. */
  (function () {
    function abre(e) {
      var modal = document.getElementById('search-modal');
      if (!modal || typeof modal.showDialog !== 'function') return;
      e.preventDefault();
      modal.showDialog();
    }
    function arranca(raiz) {
      raiz.querySelectorAll('[data-cb-buscar]').forEach(function (a) {
        if (a.dataset.cbBuscarListo === '1') return;
        a.dataset.cbBuscarListo = '1';
        a.addEventListener('click', abre);
      });
    }
    arranca(document);
    document.addEventListener('shopify:section:load', function (e) { arranca(e.target); });
  })();

  /* Abre el cajon del carrito que el tema ya monta en todas las paginas. Hasta ahora NADA lo abria:
     el cajon y su JavaScript se descargaban en cada pagina y el icono navegaba a /cart, asi que el
     componente estaba muerto (fallo 196).
     Mismo criterio que el buscador: se comprueba que el cajon EXISTE y que expone `toggle` antes de
     cancelar la navegacion. Si el modulo aun no ha definido el elemento —se carga con prioridad
     baja— el clic se deja pasar y el cliente acaba en /cart, que es una pagina que funciona. Nunca
     se traga el clic sin dar nada a cambio. */
  (function () {
    function esCajonListo(el) {
      return el && typeof el.toggle === 'function';
    }
    function abre(e) {
      /* Con modificadores el cliente esta pidiendo abrir en otra pestaña: eso no se secuestra. */
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var cajon = document.getElementById('cart-drawer');
      if (!esCajonListo(cajon)) return;
      e.preventDefault();
      cajon.toggle();
    }
    function arranca(raiz) {
      raiz.querySelectorAll('[data-cb-carrito]').forEach(function (a) {
        if (a.dataset.cbCarritoListo === '1') return;
        a.dataset.cbCarritoListo = '1';
        a.addEventListener('click', abre);
      });
    }
    arranca(document);
    document.addEventListener('shopify:section:load', function (e) { arranca(e.target); });

    /* El estado lo dice el cajon, no quien lo abrio: tambien se abre solo al añadir al carrito y se
       cierra con Escape o con el fondo. Escuchando sus eventos, `aria-expanded` no puede desfasarse. */
    function marca(valor) {
      document.querySelectorAll('[data-cb-carrito]').forEach(function (a) {
        a.setAttribute('aria-expanded', valor);
      });
    }
    document.addEventListener('theme-drawer:open', function (e) {
      if (e.target && e.target.id === 'cart-drawer') marca('true');
    });
    document.addEventListener('theme-drawer:close', function (e) {
      if (e.target && e.target.id === 'cart-drawer') marca('false');
    });
  })();

  (function () {
    const drawer = document.querySelector('[data-cb-drawer]');
    if (!drawer) return;
    const opener = document.querySelector('[data-cb-drawer-open]');
    let lastFocus = null;

    function focusables() {
      return drawer.querySelectorAll('a[href], button:not([disabled])');
    }
    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      if (opener) opener.setAttribute('aria-expanded', 'true');
      const f = focusables();
      if (f.length) f[0].focus();
    }
    function close() {
      drawer.hidden = true;
      document.body.style.overflow = '';
      if (opener) opener.setAttribute('aria-expanded', 'false');
      if (lastFocus) lastFocus.focus();
    }
    if (opener) opener.addEventListener('click', open);
    drawer.querySelectorAll('[data-cb-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      const f = focusables();
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caboki-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function arranca(wrap) {
      if (wrap.dataset.cbMqListo === '1') return;
      wrap.dataset.cbMqListo = '1';
      var boton = wrap.querySelector('[data-cb-mq-pausa]');
      if (!boton) return;
      // Un <button> nativo ya responde a Space y a Enter con `click`; no hace falta escuchar
      // teclas a mano, y hacerlo a mano es justo como se rompen estas cosas.
      boton.addEventListener('click', function () {
        var parada = wrap.classList.toggle('is-paused');
        var etiqueta = parada
          ? boton.getAttribute('data-cb-mq-label-reanudar')
          : boton.getAttribute('data-cb-mq-label-pausar');
        if (etiqueta) boton.setAttribute('aria-label', etiqueta);
      });
    }
    document.querySelectorAll('[data-cb-mq-wrap]').forEach(arranca);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-cb-mq-wrap]').forEach(arranca);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caboki-testimonios"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function monta(raiz) {
      if (raiz.dataset.cbTestiListo === '1') return;
      raiz.dataset.cbTestiListo = '1';
      var lista = raiz.querySelector('[data-cb-testi-scroller]');
      var nav = raiz.querySelector('[data-cb-testi-nav]');
      if (!lista || !nav) return;

      var prev = nav.querySelector('[data-cb-testi-prev]');
      var next = nav.querySelector('[data-cb-testi-next]');

      // Los controles solo se muestran si hay algo que desplazar de verdad.
      function revisa() {
        nav.hidden = lista.scrollWidth <= lista.clientWidth + 1;
      }

      function paso() {
        var item = lista.querySelector('.cb-testi__item');
        return item ? item.getBoundingClientRect().width + 24 : lista.clientWidth;
      }

      prev.addEventListener('click', function () { lista.scrollBy({ left: -paso() }); });
      next.addEventListener('click', function () { lista.scrollBy({ left: paso() }); });

      revisa();
      if ('ResizeObserver' in window) {
        new ResizeObserver(revisa).observe(lista);
      } else {
        window.addEventListener('resize', revisa);
      }
    }

    document.querySelectorAll('[data-cb-testi]').forEach(monta);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-cb-testi]').forEach(monta);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caboki-tonos"] && !Shopify.designMode) return;
  try {
    
  class CabokiOffer {
    constructor(root) {
      this.root = root;
      const data = root.querySelector('[data-cb-variants]');
      try { this.variants = JSON.parse(data.textContent); } catch (e) { this.variants = []; }
      this.idInput = root.querySelector('[data-cb-variant-id]');
      this.price = root.querySelector('[data-cb-price]');
      this.compare = root.querySelector('[data-cb-compare]');
      this.selected = root.querySelector('[data-cb-selected]');
      this.button = root.querySelector('[data-cb-add]');
      this.status = root.querySelector('[data-cb-status]');
      this.cartLink = root.querySelector('[data-cb-cartlink]');
      this.image = root.querySelector('.cb-offer__img');
      this.form = root.querySelector('form');
      this.pdpLinks = root.querySelectorAll('[data-cb-pdp]');
      root.querySelectorAll('[data-cb-opt]').forEach((input) => {
        input.addEventListener('change', () => this.select(input.value));
      });
      if (this.form) this.form.addEventListener('submit', (e) => this.add(e));
      this.restoreFromUrl();
    }

    // El tono elegido tiene que poder enlazarse y sobrevivir a una recarga. Sin esto, mandar
    // "mira este, en Rubio Medio" era imposible: el enlace abria siempre el primer tono.
    restoreFromUrl() {
      let id = null;
      try { id = new URL(window.location.href).searchParams.get('variant'); } catch (e) { return; }
      if (!id) return;
      const v = this.find(id);
      if (!v) return;
      const input = this.root.querySelector('[data-cb-opt][value="' + CSS.escape(String(v.id)) + '"]');
      if (input) input.checked = true;
      this.select(v.id, { push: false });
    }

    // `push:false` cuando el cambio VIENE de la URL: reescribirla ahi solo añadiria una entrada
    // de historial identica a la que el navegador ya tiene.
    syncUrl(v) {
      if (!window.history || !window.history.replaceState) return;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(v.id));
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* URL no manipulable: el resto del selector sigue funcionando */ }
    }

    find(id) {
      return this.variants.find((v) => String(v.id) === String(id)) || null;
    }

    select(id, options) {
      const v = this.find(id);
      if (!v) return;
      const push = !options || options.push !== false;
      this.idInput.value = v.id;
      if (this.price) this.price.textContent = v.price;
      if (this.compare) {
        if (v.compare) { this.compare.textContent = v.compare; this.compare.hidden = false; }
        else { this.compare.textContent = ''; this.compare.hidden = true; }
      }
      if (this.selected) this.selected.textContent = v.title;
      if (this.image && v.img) this.image.src = v.img;
      this.pdpLinks.forEach((a) => { if (v.url) a.setAttribute('href', v.url); });
      if (this.button) {
        this.button.disabled = !v.available;
        this.button.textContent = v.available
          ? this.button.dataset.labelAdd
          : this.button.dataset.labelSoldout;
      }
      if (this.status) this.status.textContent = '';
      if (this.cartLink) this.cartLink.hidden = true;
      if (push) this.syncUrl(v);
    }

    async add(event) {
      if (!window.fetch) return;
      event.preventDefault();
      const v = this.find(this.idInput.value);
      if (!v || !v.available) return;
      const label = this.button.textContent;
      this.button.disabled = true;
      this.button.textContent = this.button.dataset.labelAdding;
      if (this.status) this.status.textContent = '';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        });
        if (!res.ok) throw new Error('cart');
        this.button.textContent = this.button.dataset.labelAdded;
        if (this.status) this.status.textContent = this.button.dataset.labelAdded + ': ' + v.title;
        if (this.cartLink) this.cartLink.hidden = false;
      } catch (err) {
        this.button.textContent = label;
        if (this.status) this.status.textContent = this.button.dataset.labelError;
      } finally {
        this.button.disabled = false;
      }
    }
  }

  document.querySelectorAll('[data-cb-offer]').forEach((el) => new CabokiOffer(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caboki-uso"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function sincronizaAcordeones(raiz) {
      raiz.querySelectorAll('.cb-uso__misscard').forEach(function (item) {
        var resumen = item.querySelector('.cb-uso__missq');
        if (!resumen || item.dataset.cbSync === '1') return;
        item.dataset.cbSync = '1';
        var sync = function () { resumen.setAttribute('aria-expanded', item.open ? 'true' : 'false'); };
        sync();
        item.addEventListener('toggle', sync);
      });
    }

    var observador = null;
    if ('IntersectionObserver' in window) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('cb-in');
          observador.unobserve(entrada.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
    }

    if (!window.cbRevelar) {
      window.cbRevelar = function (raiz) {
        if (!observador) return;
        raiz.setAttribute('data-cb-anim', 'on');
        raiz.querySelectorAll('[data-cb-reveal]').forEach(function (el) {
          if (el.getBoundingClientRect().top < window.innerHeight * 0.9) { el.classList.add('cb-in'); return; }
          observador.observe(el);
        });
      };
    }

    // El timeline marca como activo el paso que cruza el CENTRO del viewport. Sin listener de scroll
    // y sin umbral que perseguir: el rootMargin recorta la zona sensible al centro, que es lo que
    // evita el parpadeo del que avisa HIVE. Y NO se toca el scroll del usuario en ningun momento.
    function montaSecuencia(caja) {
      if (caja.dataset.cbSeqListo === '1') return;
      var pasos = caja.querySelectorAll('[data-cb-uso-step]');
      if (!pasos.length || !('IntersectionObserver' in window)) return;
      caja.dataset.cbSeqListo = '1';
      caja.setAttribute('data-cb-seq', 'on');

      function activa(n) {
        pasos.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-cb-uso-step') === n);
        });
      }

      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) activa(e.target.getAttribute('data-cb-uso-step'));
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

      pasos.forEach(function (p) { obs.observe(p); });
      activa('1');
    }

    function arranca(raiz) {
      sincronizaAcordeones(raiz);
      if (window.cbRevelar) window.cbRevelar(raiz);
      raiz.querySelectorAll('[data-cb-uso-steps]').forEach(montaSecuencia);
    }

    document.querySelectorAll('[data-cb-uso]').forEach(arranca);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-cb-uso]').forEach(arranca);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caboki-video-texto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reproduce(boton) {
      var id = boton.getAttribute('data-cb-vt-video');
      if (!id) return;
      var marco = document.createElement('div');
      marco.className = 'cb-vt__frame';
      var iframe = document.createElement('iframe');
      // Sin autoplay: el reproductor aparece listo y arranca cuando el usuario lo decide. Y en
      // dominio nocookie, que no deja rastro de seguimiento antes de eso.
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?rel=0';
      iframe.title = boton.getAttribute('data-cb-vt-title') || '';
      iframe.allow = 'clipboard-write; encrypted-media; picture-in-picture; fullscreen';
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      marco.appendChild(iframe);
      boton.replaceWith(marco);
      iframe.focus();
    }
    function arranca(raiz) {
      if (raiz.dataset.cbVtListo === '1') return;
      raiz.dataset.cbVtListo = '1';
      raiz.querySelectorAll('.cb-vt__btn').forEach(function (b) {
        b.addEventListener('click', function () { reproduce(b); });
      });
    }
    document.querySelectorAll('[data-cb-vt]').forEach(arranca);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-cb-vt]').forEach(arranca);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caboki-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reproduce(boton) {
      var id = boton.getAttribute('data-cb-video');
      if (!id) return;
      var marco = document.createElement('div');
      marco.className = 'cb-vids__frame';
      var iframe = document.createElement('iframe');
      // Sin autoplay por orden del director: el reproductor aparece listo y arranca cuando el
      // usuario lo decide. Y en dominio nocookie, que no deja rastro de seguimiento antes de eso.
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?rel=0';
      iframe.title = boton.getAttribute('data-cb-video-title') || '';
      iframe.allow = 'clipboard-write; encrypted-media; picture-in-picture; fullscreen';
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      marco.appendChild(iframe);
      boton.replaceWith(marco);
      iframe.focus();
    }

    function arranca(raiz) {
      if (raiz.dataset.cbVidsListo === '1') return;
      raiz.dataset.cbVidsListo = '1';
      raiz.querySelectorAll('.cb-vids__btn').forEach(function (boton) {
        boton.addEventListener('click', function () { reproduce(boton); });
      });
      if (window.cbRevelar) window.cbRevelar(raiz);
    }

    document.querySelectorAll('[data-cb-vids]').forEach(arranca);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-cb-vids]').forEach(arranca);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
